module.exports = __webpack_public_path__ + "static/media/reasons-background.dc3b1001.png";